module.exports = __webpack_public_path__ + "img/email.ad1478e8.svg";